import { render, staticRenderFns } from "./VehicleRegistrationPlateCard.vue?vue&type=template&id=9e5e0262&"
import script from "./VehicleRegistrationPlateCard.vue?vue&type=script&lang=ts&"
export * from "./VehicleRegistrationPlateCard.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleRegistrationPlateCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports